<template>
  <FormItem :name="name">
    <input :list="listId" v-model="selected" />
    <datalist :id="listId">
      <option
        v-for="(item, index) in options"
        :key="index"
        :value="item"
        :selected="item.id == selected.id"
      >
        {{ displayOptions[index] }}
      </option>
    </datalist>
    <!--div class="debug">
            <p>selected = {{ selected }}</p>
            <p>options[0] = {{ props.options[0] }}</p>
        </div-->
  </FormItem>
</template>

<script setup lang="ts">
/**
 * Form listbox is input with type list, and datalist of options
 */
import FormItem from './Form-item.vue'
import { computed } from 'vue'
const props = defineProps({
  name: { type: String, required: true },
  // placeholder: { type: String},
  options: { type: Array<any> }, //this should just be plain string arrays
  displayOptions: { type: Array<String> }
})

//generate random (hopefully unique) id
const listId = computed(() => {
  let x = Math.floor(Math.random() * 1000000 + 1)
  return `datalist-${props.name}-${x}`
})

const selected = defineModel<any>('selected')
</script>
